import { useCallback } from 'react';
import { useStore } from '../store/store';

export const useCalorieCalculation = () => {
  const {
    gender,
    born,
    birthDate,
    height,
    weight
  } = useStore();

  const calculateCalories = useCallback((): number => {
    const FALLBACK_CALORIES = 1500;

    if (!gender || !height || !weight) {
      return FALLBACK_CALORIES;
    }

    let age: number = 0;
    
    if (born) {
      age = parseInt(born as string) || 0;
    } else if (birthDate) {
      const birthDateObj = birthDate as { year: string; month: string; day: string };
      const birth = new Date(
        parseInt(birthDateObj.year),
        parseInt(birthDateObj.month) - 1,
        parseInt(birthDateObj.day)
      );
      const today = new Date();
      age = today.getFullYear() - birth.getFullYear();
      
      const monthDiff = today.getMonth() - birth.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
    } else {
      return FALLBACK_CALORIES;
    }

    let heightInCm: number;
    
    if (height.type === "cm" && height.cm) {
      heightInCm = parseFloat(height.cm);
    } else if (height.type === "ft" && height.ft) {
      const feet = parseFloat(height.ft);
      heightInCm = feet * 30.48;
    } else {
      return FALLBACK_CALORIES;
    }

    let weightInKg: number;
    
    if (weight.type === "kg" && weight.kg) {
      weightInKg = parseFloat(weight.kg);
    } else if (weight.type === "lbs" && weight.lbs) {
      const pounds = parseFloat(weight.lbs);
      weightInKg = pounds * 0.453592;
    } else {
      return FALLBACK_CALORIES;
    }

    if (isNaN(age) || isNaN(heightInCm) || isNaN(weightInKg) || age <= 0 || heightInCm <= 0 || weightInKg <= 0) {
      return FALLBACK_CALORIES;
    }

    const bmr = gender === "Male" 
      ? (10 * weightInKg + 6.25 * heightInCm - 5 * age + 5)
      : (10 * weightInKg + 6.25 * heightInCm - 5 * age - 161);

    return Math.round(bmr);
  }, [gender, born, birthDate, height, weight]);

  return calculateCalories;
};